import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-live-class-state-view-timer',
  template: `
    <span
      id="live-class-countdown-timer"
      [ngClass]="theme === 'light' ? 'theme-light' : 'theme-dark'"
      *ngIf="minutes && seconds"
    >
      <span *ngFor="let minuteDigit of minutes.split('')" class="countdown-timer-digit">
        {{ minuteDigit }}
      </span>
      <span>:</span>
      <span *ngFor="let secondDigit of seconds.split('')" class="countdown-timer-digit">
        {{ secondDigit }}
      </span>
    </span>
  `,
  styleUrls: ['./live-class-state-view-timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassStateViewTimerComponent {
  @Input() minutes: string;
  @Input() seconds: string;
  @Input() theme: 'light' | 'dark';
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/live-class-state-view-timer/live-class-state-view-timer.component.ts